<template>
    <div class="main-content-container container">
        <div class="page-header row no-gutters py-4">
            <div class="col-6 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">sessão</span>
                <h3 class="page-title">Contas Bancárias</h3>
            </div>
        </div>

        <!-- Default Light Table -->
        <TableListBA :lines="fields" :pagination.sync="pagination" :loadingList="loadingList" @List="ListBankAccount"
            @Open="OpenField" @Delete="ConfirmDelete" />

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" :title="modalTitle" id="mFormField"
            size="md">
            <!-- Loader -->
            <div v-if="loadingModal">
                <loader :is-loading="loadingModal"></loader>
            </div>
            <div v-else>
                <ValidationObserver tag="form" ref="validateFieldValidationForm">
                    <d-form-row>
                        <d-col md="12" style="margin: 0px" class="form-group">
                            <label>
                                Código Contabilidade
                            </label>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                                <input class="form-control" placeholder="Código Contabilidade"
                                    :class="validatedFieldForm | showValidateError(invalid)" :disabled="isSeeing"
                                    type="text" v-model="infoField.AccoutingCode"
                                    @input="validateNumber('AccoutingCode')" />
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="12" class="form-group">
                            <label>Banco</label>
                            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                                <d-select size="sm" v-model="infoField.Bank.Code" :disabled="isSeeing"
                                    :class="validatedFieldForm | showValidateError(invalid)">
                                    <option v-for="(bankAccount, idx) in bankAccounts" :key="idx"
                                        :value="bankAccount.Code">
                                        {{ bankAccount.Code }} - {{ bankAccount.Name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="12" class="form-group">
                            <label>Tipo de Conta</label>
                            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                                <d-select size="sm" v-model="infoField.AccountType.Code" :disabled="isSeeing"
                                    :class="validatedFieldForm | showValidateError(invalid)">
                                    <option v-for="(accountType, idx) in accountTypes" :key="idx"
                                        :value="accountType.Code">
                                        {{ accountType.Name }}
                                    </option>
                                </d-select>
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="12" style="margin: 0px" class="form-group">
                            <label>Agência</label>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">


                                <input class="form-control" placeholder="Agência"
                                    :class="validatedFieldForm | showValidateError(invalid)" :disabled="isSeeing"
                                    type="text" v-model="infoField.BankAgency" @input="validateNumber('BankAgency')" />
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ValidationProvider rules="min:1|max:1" v-slot="{ errors, validate, validated, invalid }">
                                <the-mask class="form-control" :class="validatedFieldForm | showValidateError(invalid)"
                                    type="text" :mask="['X']" v-model="infoField.BankAgencyDigit"
                                    @input="() => { validate(); validateSingleCharacter('BankAgencyDigit'); }"
                                    :disabled="isSeeing" placeholder="Digito da Agência" />
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="12" style="margin: 0px" class="form-group">
                            <label>Conta</label>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ValidationProvider rules="required|numeric" v-slot="{ errors, invalid }">
                                <d-form-input class="form-control" placeholder="Conta"
                                    :class="validatedFieldForm | showValidateError(invalid)" :disabled="isSeeing"
                                    type="text" v-model="infoField.BankAccount"
                                    @input="validateNumber('BankAccount')" />
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                        <d-col md="6" class="form-group">
                            <ValidationProvider rules="min:1|max:1" v-slot="{ errors, invalid }">
                                <the-mask class="form-control" :class="validatedFieldForm | showValidateError(invalid)"
                                type="text" :mask="['X']" v-model="infoField.BankAccountDigit"
                                @input="() => { validateSingleCharacter('BankAccountDigit'); }"
                                :disabled="isSeeing" placeholder="Digito da Conta" />
                                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                                    {{ errors[0] }}
                                </div>
                            </ValidationProvider>
                        </d-col>
                    </d-form-row>
                </ValidationObserver>
            </div>

            <template slot="modal-footer" slot-scope="{ cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button size="sm" @click="cancel()">Fechar</b-button>
                <b-button size="sm" variant="success" @click="SaveField()"
                    v-if="!isSeeing || (isSeeing && loadingAddUpdate)" :disabled="loadingAddUpdate || loadingModal">
                    <template v-if="!loadingAddUpdate">
                        {{ pOpened != null ? " Salvar" : " Adicionar" }}
                        <i class="fas fa-arrow-right"></i>
                    </template>
                    <template v-else>
                        <loader :small="true" :isLoading="loadingAddUpdate"></loader>
                    </template>
                </b-button>
            </template>
        </b-modal>
        <b-modal id="mConfirmAction" title="Confirmar Ação" centered>
            <!--Confirmar Ação de Exclusão-->
            <loader :is-loading="loadingInfo"></loader>
            <template v-if="!loadingInfo">
            <p>
                Você tem certeza que deseja DESATIVAR o Banco {{infoField.Bank.Name  }} Agência {{infoField.BankAgency}} Conta {{infoField.BankAccount}}-{{infoField.BankAccountDigit}}?
            </p>
           
            <d-form-row v-if="true"> 
              <d-col md="6" class="form-group">
                <label>
                    Usuário
                </label>
      
                <d-form-input type="text" v-model="$getUserInternal().Name" readonly
                  disabled
                />
              </d-col>
      
              <d-col md="6" class="form-group">
                <label>
                    Data da desativação
                </label>
                <d-form-input
                  type="text"
                  v-bind:value=" new Date() | date('DD/MM/YYYY - HH:mm')"
                  readonly
                />
              </d-col>     
            </d-form-row>
            <ValidationObserver tag="form" ref="validateFieldValidationForm">
              <label class="font-weight-bold">Motivo da desativação</label>
              <ValidationProvider rules="required|min:15|max:1000" v-slot="{ errors, invalid }">
                <b-form-textarea
                  :class="validateExclusionReason | showValidateError(invalid)"
                  v-model="Disable.Description"
                  :value="Disable.Description"
                  :readonly="false"
                  id="custom-formarea"
                  tabindex="-1"
                  type="text"
                />
                <div class="invalid-feedback d-block" v-if="validateExclusionReason">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </ValidationObserver>
            <template slot="modal-footer">
              <b-button variant="secondary" class="btn btn-secondary" v-b-tooltip.hover.bottom title="Cancelar" @click="$bvModal.hide('mConfirmAction')">
                Cancelar
              </b-button>
              <b-button
                variant="danger"
                class="btn btn-danger"
                v-b-tooltip.hover.bottom
                title="Remover"
                @click="DeleteBankAccount(idField)"
              >
                Sim
              </b-button>
            </template>
          </template>
          </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" centered id="mFilter" title="Filtros">
            <d-form-row>
                <d-col md="12" class="form-group">
                    <label>Banco</label>
                    <d-select size="sm" v-model="filter.Bank.Code">
                        <option :value="null">Selecione</option>
                        <option v-for="(bankAccount, idx) in bankAccounts" :key="idx" :value="bankAccount.Code">
                            {{ bankAccount.Code }} - {{ bankAccount.Name }}
                        </option>
                    </d-select>
                </d-col>
                <d-col md="12" class="form-group">
                    <label>Tipo de Conta</label>
                    <d-select size="sm" v-model="filter.AccountType.Code">
                        <option :value="null">Selecione</option>
                        <option v-for="(accountType, idx) in accountTypes" :key="idx" :value="accountType.Code">
                            {{ accountType.Name }}
                        </option>
                    </d-select>
                </d-col>
                <d-col md="12" class="form-group">
                    <label>Status da Conta</label>
                    <d-select size="sm" v-model="filter.IsExcluded">
                        <option :value="false">Ativos</option>
                        <option :value="true">Inativos</option>
                    </d-select>
                </d-col>
            </d-form-row>

            <template slot="modal-footer">
                <b-button @click="Filter()" class="btn btn-primary" title="Pesquisar" v-b-tooltip.hover.bottom
                    variant="primary">
                    <i class="fas fa-search"></i>
                </b-button>
                <b-button @click="ResetFilter()" class="input-group-text" title="Limpar filtros"
                    v-b-tooltip.hover.bottom variant="primary">
                    <i class="fas fa-eraser"></i>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, numeric, min, max } from "vee-validate/dist/rules";
import { mapActions, mapState } from "vuex";
import TableListBA from "./TableListBA.vue";
import { valid } from "semver";

extend("max", {
    ...max,
    message: "O dígito deve ter no máximo {length} caractere(s)",
});
extend("min", {
    ...min,
    message: "O dígito deve ter pelo menos {length} caractere(s)",
});
extend("required", {
    ...required,
    message: "Este campo é obrigatório",
});
extend("numeric", {
    ...numeric,
    message: "Este campo deve conter apenas números",
});

export default {
    name: "RegistrationsBankAccount",
    components: {
        TableListBA,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            fields: [],
            bankAccounts: [],
            accountTypes: [],

            Disable: {
                Id: 0,
                Description: null,
            },
            filter: {
                AccoutingCode: null,
                Bank: { Code: null },
                AccountType: { Code: null },
                BankAgency: null,
                BankAgencyDigit: null,
                BankAccount: null,
                BankAccountDigit: null
            },
            infoField: {
                Bank: { Code: null },
                AccountType: { Code: null },
                BankAgency: null,
                BankAgencyDigit: null,
                BankAccount: null,
                BankAccountDigit: null,
                AccoutingCode: null
            },
            pagination: {
                PageNumber: 1,
                RowsPerPage: 10,
                TotalItems: 0
            },
            validateExclusionReason: false,
            countFilter: 0,
            idField: 0,
            isSeeing: false,
            loadingAddUpdate: false,
            loadingList: false,
            loadingModal: false,
            loadingInfo: false,
            modalTitle: "Nova Categoria",
            pOpened: null,
            validatedFieldForm: false,
        };
    },
    mounted() {
        this.ListBankAccount();
        this.GetBanksAndAccountTypes();
    },

    methods: {

        ...mapActions("bankAccount", ["ListBankAccount"]),
        validateNumber(field) {
            if (!/^\d*$/.test(this.infoField[field])) {
                this.infoField[field] = this.infoField[field].replace(/\D/g, "");
            }
        },
        validateSingleCharacter(field) {
            if (this.infoField[field].Length > 1) {
                this.infoField[field] = this.infoField[field].slice(0, 1);
            }
        },
        OpenField(e, i, view) {
            e.preventDefault();
            this.validatedFieldForm = false;
            this.ResetInfoField();

            if (view == false && i != undefined) {
                // Edit
                this.pOpened = i;
                this.idField = this.fields[i].Id;
                this.isSeeing = false;
                this.modalTitle = "Editar Conta Bancária";
                this.GetBankAccount();
            } else if (view == null && i == undefined) {
                // Add new
                this.pOpened = null;
                this.isSeeing = false;
                this.modalTitle = "Nova Conta Bancária";
                this.ResetInfoField();
            } else {
                // View
                this.pOpened = i;
                this.idField = this.fields[i].Id;
                this.isSeeing = true;
                this.modalTitle = "Detalhes da Conta Bancária";
                this.GetBankAccount();
            }
            this.$bvModal.show("mFormField");
        },
        OpenModalFilter() {
            this.$bvModal.show("mFilter");
        },
        Filter() {
            this.$bvModal.hide("mFilter");
            this.ListBankAccount();
        },
        ResetFilter() {
            this.filter = filterDefault();
            this.ListBankAccount();
        },
        ResetInfoField() {
            this.infoField = {
                Bank: { Code: null },
                AccountType: { Code: null },
                BankAgency: null,
                BankAgencyDigit: null,
                BankAccount: null,
                BankAccountDigit: null,
                AccoutingCode: null
            };
        },
        SaveField() {
            this.validatedFieldForm = true;
            this.$refs.validateFieldValidationForm.validate().then((isValid) => {
                if (isValid) {
                    this.loadingAddUpdate = true;
                    this.isSeeing = true;

                    if (this.pOpened == null) {
                        // Add
                        this.$store
                            .dispatch("AddBankAccount", this.infoField)
                            .then(() => {
                                this.$makeToast(
                                    "O campo foi cadastrado com sucesso.",
                                    "success",
                                    "Campo cadastrado"
                                );
                                this.ListBankAccount();
                                this.$bvModal.hide("mFormField");
                            })
                            .catch((error) => {
                                this.$makeToast(
                                    "Tente novamente mais tarde.",
                                    "danger",
                                    "Erro ao criar campo",
                                    error
                                );
                            })
                            .finally(() => {
                                this.loadingAddUpdate = false;
                                this.isSeeing = false;
                            });
                    } else {

                        this.$store
                            .dispatch("UpdateBankAccount", this.infoField)
                            .then(() => {
                                this.$makeToast(
                                    "O Campo foi atualizado com sucesso.",
                                    "success",
                                    "Campo atualizado"
                                );
                                this.ListBankAccount();
                                this.$bvModal.hide("mFormField");
                            })
                            .catch((error) => {
                                this.$makeToast(
                                    "Erro ao atualizar campo, tente novamente.",
                                    "danger",
                                    "Erro ao atualizar campo",
                                    error
                                );
                            })
                            .finally(() => {
                                this.loadingAddUpdate = false;
                                this.isSeeing = false;
                            });
                    }
                }
            });
        },
        GetBankAccount() {
            if (this.idField != 0) {
                this.loadingModal = true;
                this.$store
                    .dispatch("GetBankAccount", { id: this.idField })
                    .then((response) => {
                        this.infoField = response;
                    })
                    .catch((error) => {
                        this.$makeToast(
                            "Um erro ocorreu ao carregar o campo",
                            "danger",
                            "Erro ao carregar o campo",
                            error
                        );
                    })
                    .finally(() => {
                        this.loadingModal = false;
                    });
            }
        },
        ListBankAccount() {
            this.loadingList = true;
            this.countFilter = 0;
            if (hasValue(this.filter.Bank.Code)) this.countFilter++;
            if (hasValue(this.filter.AccountType.Code)) this.countFilter++;
            if (hasValue(this.filter.IsExcluded)) this.countFilter++;
            let data = {
                ...this.pagination,
                "Object.Bank.Code": this.filter.Bank.Code,
                "Object.AccountType.Code": this.filter.AccountType.Code,
                "Object.IsExcluded": this.filter.IsExcluded,
            };
            delete data.TotalItems;
            this.$store
                .dispatch("ListBankAccount", { params: data })
                .then((response) => {
                    this.fields = response.Objects;
                    this.pagination.TotalItems = response.TotalItems;
                })
                .catch((error) => {
                    this.$makeToast(
                        "Um erro ocorreu ao listar os campos. Tente novamente.",
                        "danger",
                        "Erro ao listar os Campos",
                        error
                    );
                })
                .finally(() => (this.loadingList = false));
        },

        ConfirmDelete(e, id) {
            e.preventDefault();

            this.idField = id;
            this.GetBankAccount(id);
            this.$bvModal.show("mConfirmAction");
        },
        DeleteBankAccount(id) {
            this.validateExclusionReason = true;
            this.$refs.validateFieldValidationForm.validate().then((isValid) => {
                if (isValid) {
                    this.validateExclusionReason = true;
                    const payload={
                Id: id,
                ExclusionReason: this.Disable.Description
            }
            console.log(payload);
            this.$store
                .dispatch("DeleteBankAccount", payload)
                .then(() => {
                    this.$makeToast(
                        "O Campo foi removido com sucesso.",
                        "success",
                        "Campo removido"
                    );
                    this.ListBankAccount();
                    this.$bvModal.hide("mConfirmAction");
                })
                .catch((error) => {
                    this.$makeToast(
                        "Tente novamente mais tarde.",
                        "danger",
                        "Erro ao remover Campo",
                        error
                    );
                })
                .finally(() => (this.ResetDisable()));
                }
            });

        },
        ResetDisable(){
            this.Disable= {
                Id: 0,
                Description: null,
            }
        },
        preventDecimal(e) {
            if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
                e.preventDefault();
            }
        },
        paginationDefault() {
            return {
                PageNumber: 1,
                RowsPerPage: 10,
                TotalItems: 0
            }
        },
        filterDefault() {
            return {
                Bank: { Code: null },
                AccountType: { Code: null },
                BankAgency: null,
                BankAgencyDigit: null,
                BankAccount: null,
                BankAccountDigit: null,
                IsExcluded: false,
                AccoutingCode: null
            }
        },

        GetBanksAndAccountTypes() {
            const promiseBanks = this.$store.dispatch("GetBanks", {});
            const promiseAccountTypes = this.$store.dispatch("ListAccountType", {});

            Promise.all([
                promiseBanks.catch((error) => {
                    this.$makeToast(
                        "Um erro ocorreu ao listar os bancos. Tente novamente.",
                        "danger",
                        "Erro ao listar os Bancos",
                        error
                    );
                }),
                promiseAccountTypes.catch((error) => {
                    this.$makeToast(
                        "Um erro ocorreu ao listar os tipos de contas. Tente novamente.",
                        "danger",
                        "Erro ao listar os Tipos de Contas",
                        error
                    );
                }),
            ])
                .then(([responseBanks, responseAccountTypes]) => {
                    this.bankAccounts = responseBanks;
                    this.accountTypes = responseAccountTypes;

                    this.bankAccounts.sort((a, b) => a.Code.localeCompare(b.Code));
                    this.accountTypes.sort((a, b) => a.Name.localeCompare(b.Name));
                })
                .finally(() => (this.loadingList = false));
        },
    },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/pages/RegistrationsBankAccount.vue